
    <div class="ui-g-12">
      <div class="ui-g-12 ui-g-nopad sf-field-container">
        <div class="ui-g-12 ui-md-4">
          <span class="label">
            {{ schema.description }}
          </span>
        </div>
        <div class="ui-g-12 ui-md-8">
          <input
            type="text"
            pInputText
            class="fieldInput"
            [name]="name"
            [attr.readonly]="schema.readOnly?true:null"
            [attr.id]="id"
            [formControl]="control"
            [attr.placeholder]="schema.placeholder"
            [attr.maxlength]="schema.maxLength||null"
            [attr.minlength]="schema.minLength||null"
            [attr.size]="schema.widget?.size||null"
            [disabled]="schema.readOnly||false"
            [(ngModel)]="imgUrl">
        </div>
        <div class="ui-g-4 ui-md-2">
        <button *ngIf="sec"
            (click)="pasteFromClipboard()"
            pButton
            type="button"
            label="{{'common.pasteFromClipboard' | translate}}">
    </button>
        </div>
        <div class="ui-g-6 ui-md-3">
        <button *ngIf="schema.btnUploadVisible"
        (click)="goToImagesRepository()"
        pButton
        data-testid="OpenImagesRepository"
        type="button"
        label="{{'common.OpenImagesRepository' | translate}}">
</button>
      </div>
      <!-- Anteprima Immagine -->
      <div class="ui-g-12">
        <img [hidden]="!imgUrl" [src]="imgUrl" width="100%" alt="anteprima immagine">
      </div>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/views/administration/apps-config/json-schema-form/custom-widgets/image-url.widget.ts.ImageUrlWidget.html